import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.6835 14.8404C11.8436 15.0476 12.1564 15.0476 12.3165 14.8404L15.7519 10.3946C15.9551 10.1317 15.7677 9.75 15.4354 9.75H8.5646C8.23232 9.75 8.04492 10.1317 8.24808 10.3946L11.6835 14.8404Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }